import React from 'react'
import { Modal, Form, Input, Select, DatePicker, Radio, Button } from 'antd'
import moment from "moment"

const FormItem = Form.Item;
const { RangePicker } = DatePicker;
const RadioGroup = Radio.Group;

const CollectionEditForm = Form.create()(
  class extends React.Component {
    render() {

      const { visible, onCancel, onUpdate, form, selectedEvent, loading, loadingUpdate, deleteEvent } = this.props;
      const { getFieldDecorator } = form;

      return (
        <Modal
          visible={visible}
          title="Edit existing event"
          onCancel={onCancel}
          centered
          footer={[
            <Button key="submit" ghost type="danger" loading={loading} onClick={deleteEvent}>
              Delete
            </Button>,
            <Button key="update" ghost type="primary" loading={loadingUpdate} onClick={onUpdate}>Update</Button>,
            <Button key="back" onClick={onCancel}>Return</Button>,
          ]}
        >
          <Form layout="vertical">
            <FormItem label="Title" style={{ marginBottom: 0 }}>
              {getFieldDecorator('title', {
                rules: [{ required: true, message: 'Please input the title of the event!' }],
                initialValue: selectedEvent.title
              })(
                <Input />
              )}
            </FormItem>
            <FormItem label="Description" style={{ marginBottom: 0 }}>
              {getFieldDecorator('description', {
                initialValue: selectedEvent.desc
              })(
                <Input type="textarea" />
              )}
            </FormItem>
            <FormItem label="Colour" style={{ marginBottom: 0 }}>
              {getFieldDecorator('color', {
                rules: [{ required: true, message: 'Please select a colour.' }],
                initialValue: selectedEvent.color
              })(
                <Select>
                  <Select.Option value='Red'>Red</Select.Option>
                  <Select.Option value='Blue'>Blue</Select.Option>
                  <Select.Option value='Green'>Green</Select.Option>
                  <Select.Option value='Yellow'>Yellow</Select.Option>
                  <Select.Option value='Purple'>Purple</Select.Option>
                  <Select.Option value='Orange'>Orange</Select.Option>
                </Select>
              )}
            </FormItem>
            <FormItem label="Date" style={{ marginBottom: 0 }}>
              {getFieldDecorator('range', {
                rules: [{ required: true, message: 'Please select a date.' }],
                initialValue: [moment(selectedEvent.start), moment(selectedEvent.end)]
              })(
                <RangePicker
                  showTime={{ format: 'HH:mm', defaultValue: [moment('00:00', 'HH:mm'), moment('00:00', 'HH:mm')] }}
                  format="DD-MM-YYYY HH:mm"
                  placeholder={['Start date', 'End date']}
                  style={{ width: '100%' }}
                />
              )}
            </FormItem>
            <FormItem label="All Day?" style={{ marginBottom: 0 }}>
              {getFieldDecorator('allDay', {
                initialValue: Boolean(selectedEvent.allDay)
              })(
                <RadioGroup>
                  <Radio value={true}>Yes</Radio>
                  <Radio value={false}>No</Radio>
                </RadioGroup>
              )}
            </FormItem>
            <FormItem style={{ marginBottom: 0, display: 'none' }}>
              {getFieldDecorator('id', {
                initialValue: selectedEvent.id
              })(
                <Input disabled/>
              )}
            </FormItem>
          </Form>
        </Modal>
      );
    }
  }
);

export default CollectionEditForm